import classNames from 'classnames';
import React, { useState } from 'react';
import Image from 'react-bootstrap/Image';
import { createUseStyles } from 'react-jss';
import { useCloudinary } from '../../hooks/use-cloudinary';
import { ProductImagePlaceholder } from '../product-image-placeholder';

const animate = 'animate__animated animate__fadeIn';

function ProductImage({ onClick, image /* onZoomChange */ }) {
  const { transform } = useCloudinary();
  const [loaded, setLoaded] = useState(false);
  // const zoomRef = useRef();
  const classes = useStyles();

  const handleOnClick = () => {
    onClick?.call(this, image);
  };

  // const resetZoom = () => {
  //   _.delay(() => {
  //     zoomRef.current.reset();
  //   }, 200);
  // };

  return (
    <div className={classes.container}>
      {!loaded && <ProductImagePlaceholder absolute />}
      {/* <PrismaZoom
        ref={zoomRef}
        allowTouchEvents
        allowParentPanning
        allowPan={false}
        allowWheel={false}
        onZoomChange={onZoomChange}
        maxZoom={1.8}
      > */}
      <Image
        className={classNames(classes.image, animate)}
        onClick={handleOnClick}
        src={transform(image.url)}
        onLoad={() => setLoaded(true)}
        // onTouchEnd={resetZoom}
        // onDragEnd={resetZoom}
        // onAnimationEnd={resetZoom}
        fluid
      />
      {/* </PrismaZoom> */}
    </div>
  );
}

const useStyles = createUseStyles({
  container: {
    display: 'flex',
    flexGrow: 1,
    alignItems: 'center',
    justifyContent: 'center',
    // border: "1px solid white",
  },
  image: {
    touchAction: 'pan-x pan-y',
    // touch-action: pan-x pan-y;
  },
});

export { ProductImage };
